// extracted by mini-css-extract-plugin
module.exports = {"Container":"GeneralSetting_Container__CxOJZ","Heading":"GeneralSetting_Heading__30xLP"};